export default __webpack_public_path__ + "static/media/main.ccfccb4a.jpg";